import React from 'react';
import PropTypes from 'prop-types';
import { SFNotification } from "utils/types";
import { SFSurveysTenantLanguage } from "utils/types";
import { checkLastViewedSurvey } from "utils/surveys";
import css from './App.css';
import { hot } from 'react-hot-loader';
import { withNotification } from "common/withNotification";
import SurveyContainer from './SurveyContainer';
import { HashRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

class App extends React.Component {

  constructor() {
    super();
    this.state = { surveys: null, forceDefaultSurveyId: false };
  }
  
  updateURL() {
    const hash = `#/survey/${this.surveyId}`;
    const href = window.location.href.split("#")[0] + hash;
    history.replaceState(null, '', href);
  }

  onSurveysFetched({surveys}, forceDefaultSurveyId = false) {
    this.setState({surveys: surveys, forceDefaultSurveyId: forceDefaultSurveyId}, () => {
      if ( this.state.surveys.length > 0 && this.state.forceDefaultSurveyId ) {
        this.updateURL();
        this.setState({forceDefaultSurveyId: false});
      }
    });
    this.props.updateSurveyCount(this.state.surveys.length);
  }
  
  // If there is a lastViewedSurvey in localStorage, use that, if not grab the first ID in the array
  get defaultSurveyId() {
    const { surveys } = this.state;
    const lastViewedSurveyId = checkLastViewedSurvey();
    if ( surveys.some(survey => survey.surveyId === lastViewedSurveyId) ) return lastViewedSurveyId;
    return surveys[0].surveyId;
  }

  get surveyId() {
    const { surveys } = this.state;
    if ( !surveys || surveys.length < 1 ) return null;
    if ( this.state.forceDefaultSurveyId ) return this.defaultSurveyId;
    return window.location.href.split("#/survey/")[1] ? parseInt(window.location.href.split("#/survey/")[1]) : this.defaultSurveyId;
  }

  renderSurvey() {
    return (
      <SurveyContainer
        surveys={this.state.surveys}
        surveyId={this.surveyId}
        onSurveysFetched={this.onSurveysFetched.bind(this)}
        onFailure={this.props.notification.error}
        getStudentFolderLink={this.props.getStudentFolderLink}
        rebindStudentCards={this.props.rebindStudentCards}
        progressSurveyWords={this.props.progressSurveyWords}
      />
    );
  }

  get router() {
    return (
      <Router>
        <Switch>
          <Redirect
            exact from="/(studentInterventionsList|studentList)"
            to="/"
          />
          <Route
            exact path="/"
            render={this.renderSurvey.bind(this)}
          />
          <Route
            exact path="/(survey|studentFolder)/:id?"
            render={this.renderSurvey.bind(this)}
          />
          <Route
            render={() => <div className={css['not-found']}>No survey found!</div>}
          />
        </Switch>
      </Router>
    )
  }

  render() {
    return (
      <div className={css['container']}>
        {this.props.notification.render()}
        {this.router}
      </div>
    )
  }
}

App.propTypes = {
  getStudentFolderLink: PropTypes.func.isRequired,
  rebindStudentCards: PropTypes.func.isRequired,
  updateSurveyCount: PropTypes.func.isRequired,
  notification: SFNotification,
  progressSurveyWords: SFSurveysTenantLanguage
};

export default hot(module)(withNotification(App));
